<template>
<div :class="['main-container', { 'has-nav': showNav }]">
  <Navbar :user="user" v-if="showNav" />
  <main class="app-main">
    <router-view></router-view>
  </main>
</div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';

export default {
  data: () => ({
    user: null,
  }),
  components: {
    Navbar,
    // Footer,
  },
  computed: {
    showNav() {
      return !!(this.user && this.user.role);
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem('user'));
  },
};
</script>

<style>
@media screen {
  .product-list, .product-list * {
    visibility: hidden;
  }
}
@media print {
  /* Hide everything */
  body * {
    visibility: hidden;
  }

  /* Then display only the product list and its children */
  .product-list, .product-list * {
    visibility: visible;
  }

  /* Adjust the position to be printable */
  .product-list {
    position: absolute;
    left: 0;
    top: 0;
  }

  /* Screens that print themselves (e.g. invoice reports) opt in with
     .print-area; render them black on white instead of the dark theme. */
  .print-area, .print-area * {
    visibility: visible;
    color: #000 !important;
    background: transparent !important;
    box-shadow: none !important;
    border-color: #bbb !important;
  }

  /* Inputs are tinted `bg-dark text-white` by the views; outrank that */
  .print-area .form-control,
  .print-area .form-control.bg-dark.text-white {
    background: #fff !important;
    color: #000 !important;
  }

  .print-area {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }

  .main-container.has-nav .app-main {
    padding-left: 0 !important;
  }
}

html, body {
  position: relative;
}

.main-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  color: var(--text);
}

.app-main {
  flex: 1 1 auto;
  width: 100%;
  padding: 8px clamp(16px, 2.2vw, 40px) 56px;
}

@media (min-width: 992px) {
  .main-container.has-nav .app-main {
    padding-left: calc(var(--sidebar-w) + clamp(16px, 2.2vw, 40px));
    padding-top: 16px;
  }
}
</style>
